<template>
  <transition name="fade">
  <div id="DataLoading" v-if="active">
      ...
  </div>
  </transition>
</template>

<script>
import {store} from '@/store'

export default {
  name: 'DataLoading',
  computed: {
    active () {
      return store.state.dataLoading.active
    }
  }
}
</script>

<style lang="scss">
  @import '../../scss/variables/variables';

  #DataLoading {
    position: fixed;
    bottom: 0;
    right: 0;
    background-color: $brandSalmon50;
    border-radius: 50px;
    color: white;
    padding: 0 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/DataLoading.vue